"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var LocalizationContext_1 = require("../context/LocalizationContext");
var messageCode_1 = require("../utils/messageCode");
function useLocalizationContext() {
    return react_1.useContext(LocalizationContext_1.LocalizationContext);
}
exports.useLocalizationContext = useLocalizationContext;
function useLocalizationMessages() {
    var context = useLocalizationContext();
    return (context && context.messages) || {};
}
exports.useLocalizationMessages = useLocalizationMessages;
function useLocalizationLocale() {
    var context = useLocalizationContext();
    return (context && context.locale) || 'en-US';
}
exports.useLocalizationLocale = useLocalizationLocale;
function useLocalization() {
    var messages = useLocalizationMessages();
    return react_1.default.useCallback(function (code, args) { return messageCode_1.getMessage(messages, code, args); }, [messages]);
}
exports.useLocalization = useLocalization;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxpemF0aW9uLmhvb2tzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL2xvY2FsaXphdGlvbi5ob29rcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFDQSw2Q0FBd0M7QUFDeEMsc0VBQW1FO0FBRW5FLG9EQUFnRDtBQUVoRCxTQUFnQixzQkFBc0I7SUFDbEMsT0FBTyxrQkFBVSxDQUEwQix5Q0FBbUIsQ0FBQyxDQUFDO0FBQ3BFLENBQUM7QUFGRCx3REFFQztBQUVELFNBQWdCLHVCQUF1QjtJQUNuQyxJQUFNLE9BQU8sR0FBNEIsc0JBQXNCLEVBQUUsQ0FBQztJQUNsRSxPQUFPLENBQUMsT0FBTyxJQUFJLE9BQU8sQ0FBQyxRQUFRLENBQUMsSUFBSSxFQUFFLENBQUM7QUFDL0MsQ0FBQztBQUhELDBEQUdDO0FBRUQsU0FBZ0IscUJBQXFCO0lBQ2pDLElBQU0sT0FBTyxHQUE0QixzQkFBc0IsRUFBRSxDQUFDO0lBQ2xFLE9BQU8sQ0FBQyxPQUFPLElBQUksT0FBTyxDQUFDLE1BQU0sQ0FBQyxJQUFJLE9BQU8sQ0FBQztBQUNsRCxDQUFDO0FBSEQsc0RBR0M7QUFFRCxTQUFnQixlQUFlO0lBQzNCLElBQU0sUUFBUSxHQUFtQix1QkFBdUIsRUFBRSxDQUFDO0lBQzNELE9BQU8sZUFBSyxDQUFDLFdBQVcsQ0FBQyxVQUFDLElBQVksRUFBRSxJQUFZLElBQUssT0FBQSx3QkFBVSxDQUFDLFFBQVEsRUFBRSxJQUFJLEVBQUUsSUFBSSxDQUFDLEVBQWhDLENBQWdDLEVBQUUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO0FBQzNHLENBQUM7QUFIRCwwQ0FHQyJ9